import React from 'react'
import { Collapse, Tabs, Icon, Radio, Row } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from "styled-components";

// Components
import Container from "../../../containers/Container";
import typo from "../../../constants/dictionaries"
import helper from "../../../helper/helper"
import columns from './colums';
import Table from "../../../components/Table";
import BieuDo_VTQT from "./BieuDo"
import { Scrollbars } from 'react-custom-scrollbars';
import Button from "../../../components/Buttons";
import constants from "../../../constants/constant"
import Api_tnn from "../../../api/api.tnn"
import message from "../../../components/Messages";
import CLNTModal from '../../../components/BaoCaoDinhKy/ChatLuongXaThai/Modal/index'
const { Panel } = Collapse;
const { TabPane } = Tabs;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
const compare = (a, b) => {
    if (a.id < b.id) {
        return 1;
    }
    if (a.id > b.id) {
        return -1;
    }
    return 0;
}
class MauQTModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            changeBieudo: 1,
            data_info_mauQT: [],
            data_doituong: [],
            doituongQT: undefined,
            isEditModalOpen: false,
            selectedRow: undefined

        }
    }

    componentDidMount() {
        this.GetTPMT_Exist()
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const {data_modal_mau} = this.props
        if(prevProps.data_modal_mau !== data_modal_mau){
            this.GetTPMT_Exist()
        }
    }

    GetTPMT_Exist = () => {
        const { data_modal_mau } = this.props;
        new Api_tnn().GetTPMT_Exist({ token: this.props.user.access_token, id_giayphep: data_modal_mau.idGiayPhep, id_tramqt: data_modal_mau.idTramQT})
            .then(res => {
                let data_doituong = []
                res.length > 0 && res.map((vl, idx) => {
                    let doituong = constants.DOI_TUONG_QUAN_TRAC.filter(x => x.id === vl)
                    data_doituong.push(doituong[0])
                })
                this.setState({
                    data_doituong: data_doituong.sort(compare),
                    doituongQT: data_doituong.length > 0 ? data_doituong[0].id : undefined
                })
                data_doituong.length > 0 && this.GetMauQTs_By_TramQT(data_modal_mau.idGiayPhep, data_modal_mau.idTramQT, data_doituong[0].id)
            })
            .catch(err => {
                message.error(err.message)
            })
    };

    GetMauQTs_By_TramQT = (idGiayPhep, id_TramQT, doiTuongQT) => {
        new Api_tnn()
            .GetMauQTs_By_TramQT({ token: this.props.user.access_token, idGiayPhep: idGiayPhep, id_TramQT: id_TramQT, doiTuongQT: doiTuongQT })
            .then((res) => {
                let data = []
                res && res.map((vl, idx) => {
                    let data_mau = vl.data && vl.data.map((item, idx) => ({ ...item, dot: vl.dot, nam: vl.nam }))
                    data = data.concat(data_mau);
                })
                this.setState({
                    data_info_mauQT: data,
                })
            })
            .catch((err) => {
                message.error(err.message);
            });
    };


    showDetail = (row) => {
        this.setState({
            selectedRow: row,
            isEditModalOpen: true
        })
    }
    handleCloseModal = () => {
        this.setState({
          isEditModalOpen: false,
          selectedRow: null
        })
      };
    onChangeTabs = (id) => {
        const { data_modal_mau } = this.props
        this.setState({ doituongQT: Number(id) })
        this.GetMauQTs_By_TramQT(data_modal_mau.idGiayPhep, data_modal_mau.idTramQT, Number(id))
    }
    render() {
        const { data_modal_mau } = this.props
        const { changeBieudo, data_doituong, data_info_mauQT, doituongQT, selectedRow, isEditModalOpen } = this.state
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Container>
                <Row type='flex' justify='end'>
                    <Radio.Group name="radiogroup" defaultValue={1} >
                        <Radio style={radioStyle} value={1} onChange={(e) => e.target.value === 1 && this.setState({ changeBieudo: 1 })}>{typo.cscore_info_mau_QT}</Radio>
                        <Radio style={radioStyle} value={2} onChange={(e) => e.target.value === 2 && this.setState({ changeBieudo: 2 })}>{typo.cscore_chart}</Radio>
                    </Radio.Group>
                </Row>
                <div className="mt-20"></div>
                {changeBieudo === 1 &&
                    <div>
                        <Tabs tabPosition='left' onChange={this.onChangeTabs}>
                            {data_doituong.map((vl, idx) => <TabPane tab={vl.ten} key={vl.id}>
                                <Scrollbars autoHeight autoHeightMax={500} autoHeightMin={100} autoHide autoHideTimeout={1000} autoHideDuration={200}>
                                    <Table
                                        columns={columns({ showDetail: this.showDetail })}
                                        dataSource={helper.addSttToDataSource(data_info_mauQT)}
                                        pagination={false}
                                    />
                                </Scrollbars>
                            </TabPane>)}
                        </Tabs>
                    </div>}
                {changeBieudo === 2 &&
                    <div style={{ minHeight: 500 }}>
                        <BieuDo_VTQT
                            idGiayPhep={data_modal_mau.idGiayPhep}
                            idTramQT={data_modal_mau.idTramQT}
                        />
                    </div>}
                {isEditModalOpen &&
                    <CLNTModal
                        initialValues={selectedRow}
                        isOpen={isEditModalOpen}
                        handleCancel={this.handleCloseModal}
                        handleOk={() => { }}
                        isEdit={true}
                        mode="edit"
                        view="view"
                        doiTuongQT={doituongQT}
                        idGiayPhep={data_modal_mau.idGiayPhep}
                    />}
            </Container>
        )
    }
}

MauQTModal.propTypes = {
    handleCloseModal: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
    user: state.oidc.user
});

export default connect(mapStateToProps)(MauQTModal)